import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['120 Complete Ready-to-Teach Dance Fitness Classes', '120 Professional Choreography Systems', 'Complete Cueing & Coaching System', 'Class Planning Frameworks', 'Progressive Difficulty Systems — all levels', 'Music & Playlist Organization Guides', 'Warm-Up, Mobility & Cool-Down Libraries', 'Movement Combination Libraries', 'Class Structure Templates — 30, 45 & 60 minutes', 'Instructor Cue Sheets', 'Participant Progress & Attendance Trackers', 'Class Preparation Checklists', 'Printable Instructor Resources', 'Bonus 1 — 100 Ready-to-Use Class Ideas', 'Bonus 2 — 50 Complete Lesson Plans', 'Bonus 3 — 365 Warm-Ups, Cool-Downs & Combinations', 'Bonus 4 — Dance Fitness Monthly Challenges', 'Bonus 5 — Instructor Planner & Business Toolkit', '7-Day Money-Back Guarantee', 'Immediate Access · Local Currency · PDF Format'];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-charcoal px-4 py-20 text-white sm:py-24" data-id="element-101">
      <div className="absolute inset-x-0 top-0 h-96 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,.12),transparent_65%)]" aria-hidden="true" data-id="element-102" />
      <div className="relative mx-auto max-w-4xl" data-id="element-103">
        <header className="text-center" data-id="element-104">
          <h2 className="font-display text-3xl font-bold leading-tight sm:text-5xl" data-id="element-105">
            Next Monday you can keep building your classes from scratch...
            <br data-id="element-106" />
            <span className="text-gold-light" data-id="element-107">
              Or walk into the studio with everything ready — starting today.
            </span>
          </h2>

          <div className="mx-auto my-10 max-w-2xl space-y-3 rounded-2xl border border-charcoal-line bg-charcoal-card p-6 text-left" data-id="element-108">
            {['No more Sunday evenings searching for choreography ideas that actually work', 'No more classes that feel rushed, flat, or improvised in the moment', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost to planning instead of resting and living your life', 'No more walking into the studio wishing you had prepared more', 'No more building everything from scratch when you could open, choose, and teach'].map(item => <p key={item} className="flex gap-3 text-sm text-zinc-300" data-id="element-109">
                <span className="text-gold-light" data-id="element-110">▸</span>
                {item}
              </p>)}
          </div>

          <p className="text-lg text-zinc-100" data-id="element-111">
            Dance Fitness Instructor Pro™ does not make you a better
            instructor.
          </p>
          <p className="mt-2 text-xl font-bold text-gold-light" data-id="element-112">
            You are already a great instructor.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-zinc-300" data-id="element-113">
            It gives you the time, the tools, and the complete system to make
            that visible in every class you teach, every week of the year.
          </p>
        </header>

        <article className="mt-14 rounded-3xl border border-gold/35 bg-charcoal-card p-7 shadow-[0_0_42px_rgba(212,175,55,.1)] sm:p-10" data-id="element-114">
          <h3 className="border-b border-charcoal-line pb-5 text-center font-display text-2xl font-bold" data-id="element-115">
            Everything That's Included — One Final Look:
          </h3>
          <div className="mt-7 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-116">
            {included.map(item => <p key={item} className="flex items-center gap-2 text-sm text-zinc-200" data-id="element-117">
                <CheckIcon size={16} className="shrink-0 text-gold-light" data-id="element-118" />
                {item}
              </p>)}
          </div>

          <div className="mt-9 text-center" data-id="element-119">
            <p className="rounded-xl border border-gold/20 bg-gold/10 p-5 text-base italic text-zinc-200" data-id="element-120">
              “The best time to have this teaching system was before your very
              first class.
              <br data-id="element-121" />
              <strong className="not-italic text-gold-light" data-id="element-122">
                The second best time is today.
              </strong>
              ”
            </p>
            <p className="mt-7 font-display text-xl font-bold" data-id="element-123">
              Dance Fitness Instructor Pro™
            </p>
            <p className="mx-auto mt-2 max-w-xl text-sm text-zinc-400" data-id="element-124">
              120 complete ready-to-teach dance fitness classes — created to
              help instructors plan less, teach with confidence, and deliver an
              unforgettable session every week of the year.
            </p>
            <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-125">
              GET THE COMPLETE TEACHING SYSTEM NOW
            </CheckoutButton>
            <p className="mt-5 text-xs text-zinc-500" data-id="element-126">
              7-Day Money-Back Guarantee · Secure Payment · Immediate Access ·
              Pay in Your Local Currency
            </p>
          </div>
        </article>
      </div>
    </section>;
}